import ProductCardSkeleton from "./ProductCardSkeleton";

const ProductGridSkeleton = ({ count = 12 }) => (
  <div className="product-category-wrapper" aria-hidden="true">
    {Array.from({ length: count }).map((_, index) => (
      <ProductCardSkeleton key={index} />
    ))}
  </div>
);

export default ProductGridSkeleton;
